import { useThemeQueries } from "views/theme";
import { DialogSaurus } from "../dialog-saurus/dialog-saurus"
import { useCadastros, useToastSaurus } from "services/app";
import { Controller, useForm } from "react-hook-form";
import { TextFieldSaurus } from "views/components/controles/inputs";
import { Box, Button } from "@material-ui/core";
import { useState } from "react";
import { CircularLoading } from "views/components/utils";

interface DialogPropagandaAddParametrosProps {
    openned: boolean;
    onClickEnviarDestinatários: (parametros: string) => Promise<void>;
    parametroAnterior?: string
}

export const DialogPropagandaAddParametros = ({ openned, onClickEnviarDestinatários, parametroAnterior }: DialogPropagandaAddParametrosProps) => {
    const { isMobile } = useThemeQueries();
    const { fecharCadastroPropagandaAddParametros, fecharCadastroPropagandaResposta } = useCadastros();
    const { showToast } = useToastSaurus()
    const [isLoading, setIsLoading] = useState(false);

    const onSubmit = async (data: { parametros: string }) => {
        try {
            setIsLoading(true);
            await onClickEnviarDestinatários(data.parametros);
            fecharCadastroPropagandaAddParametros()
            fecharCadastroPropagandaResposta()
        } catch (err: any) {
            showToast('error', err.message)
        } finally {
            setIsLoading(false);
        }
    }

    const { handleSubmit, control } = useForm<{
        parametros: string;
    }>({
        defaultValues: {
            parametros: parametroAnterior || ''
        }
    });

    return (
        <DialogSaurus
            aberto={openned}
            titulo={'Adicionar Parâmetros do Destinatário'}
            tamanho="lg"
            fullScreen={isMobile}
            isButtonTitleClose
            handleClickClose={fecharCadastroPropagandaAddParametros}
            bottomArea={
                <Box p={3}>
                    <Button type="submit" color="primary" variant="contained" fullWidth size="large" onClick={handleSubmit(onSubmit)}>
                        Enviar
                    </Button>
                </Box>
            }
        >
            {isLoading && <CircularLoading tipo="FULLSIZED" />}
            <Box component="form" onSubmit={handleSubmit(onSubmit)}>
                <Controller
                    name="parametros"
                    control={control}
                    render={({ field }) => (
                        <TextFieldSaurus
                            {...field}
                            tipo="TEXTO"
                            variant="outlined"
                            label="Parâmetros"
                            multiline
                            minRows={4}
                            min={undefined}
                            max={undefined}
                        />
                    )}
                />
            </Box>
            <button type="submit" style={{ display: 'none' }}></button>
        </DialogSaurus>
    )
}